import React, { useState } from 'react'
import Box from '@/atoms/Box'
import Link from '@/atoms/Link'
import TextField from '@/components/TextField'
import { SanityMenuLink } from 'web/types/graphql-types'
import Text from '@/atoms/Text'
import underline from '@/assets/mobileMenuUnderline.svg'
import escape from '@/assets/escapeButton.svg'
import styled from 'styled-components'

const Escape = styled(Box)`
  background-image: url(${escape});
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
`

const Underline = styled(Box)`
  background-image: url(${underline});
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
`

interface Props {
  mobileMain: SanityMenuLink[]
  mobileSecondary: SanityMenuLink[]
  drawerOpened: boolean
  closeDrawer: () => void
}

const NavigationDrawer = (props: Props) => {
  const { mobileMain, mobileSecondary, drawerOpened, closeDrawer } = props;

  const [email, setEmail ] = useState('')

  return (
    <Box
      display={["flex", "none"]}
      height="100vh"
      overflow="hidden"
      position="fixed"
      right="0"
      top="0"
      transition=".6s"
      width={drawerOpened ? "calc(100% - 15rem)" : "0"}
      maxWidth="350px"
      borderLeft={drawerOpened ? "solid 2px white" : "none"}
      zIndex={100}
      bg="grey"
    >
      <Box
        p={'3rem 3rem 2rem 6rem'}
        display="flex"
        height="100%"
        width="100%"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-end"
      >
        <Box
          display="flex"
          ml="auto"
          justifyContent="flex-end"
          height="2.5rem"
          width="4rem"
          onClick={() => closeDrawer()}
          style={{ cursor: "pointer" }}
        >
          <Escape />
        </Box>

        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          alignItems="flex-end"
          mt="10rem"
        >
          {mobileMain &&
            mobileMain.map(({ label, link }) => (
              <Box position="relative" width="100%">
                <Link {...link} width="min-content" pl={"3rem"}>
                  <Text color="white" variant="body" py={2}>
                    {label}
                  </Text>
                </Link>
                <Box position="absolute" bottom="0" width="100%" height="23px">
                  <Underline />
                </Box>
              </Box>
            ))}
          <div id="mc_embed_signup">
            <form action="https://arys-berlin.us12.list-manage.com/subscribe/post?u=a8a5761d1fa5c1c18d56df31a&amp;id=7061eb21a5" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
              <div id="mc_embed_signup_scroll">
                <Box width="243px" alignSelf="flex-start" marginTop="7rem">
                  <TextField
                    type="email"
                    name="EMAIL"
                    id="mce-EMAIL"
                    width="243px"
                    height="34px"
                    label="enter e-mail for mailing list"
                    value={email}
                    setValue={setEmail}
                    autocomplete="email"
                    variant="primary"
                  />
                  {email && <Box display="flex" justifyContent="flex-end">
                    <Text
                      textAlign="right"
                      pt={1}
                      pr={2}
                      color="white"
                      variant="captionSmall"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        document.getElementById('mc-embedded-subscribe-form')?.submit()
                      }}
                    >
                      send
                    </Text>
                  </Box>}
                </Box>
                <div id="mce-responses" className="clear">
                  <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
                  <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
                </div>
                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true"><input type="text" name="b_a8a5761d1fa5c1c18d56df31a_7061eb21a5" tabIndex={-1} value="" /></div>
              </div>
            </form>
          </div>
        </Box>

        <Box
          m={2}
          mt="auto"
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          {mobileSecondary.map(({ label, link }) => (
            <Link {...link}>
              <Text color="white" variant="captionSmall" pl={2}>
                {label}
              </Text>
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default NavigationDrawer
